export const recommendationsSlug = 'recommendations'
export const ALL_RECIPES_COLLECTION_ID = 'ca8f71be-63ac-11e6-a693-068306404bab'
export const VEGETARIAN_COLLECTION_ID = '5c117c20-8b05-11e6-8538-065f01f5b2df'
export const ALL_RECIPES_SHORT_NAME = 'all_categories'
export const DIETARY_REQUIREMENTS_SHORT_NAME = 'dietary_requirements'
